import { GiftCard } from './giftCard.model';
import { User } from './user.model';

export interface IPostProductServiceGiftInfos {

  /****  ALL_POST_COMMON_INFORMATIONS ****/

  postId?: number;
  postTitle?: string;
  postVipStatus?: boolean;
  postDescription?: string;
  postPublishedDate?: Date;
  postStatusName?: string;
  postCategoryName?: string;
  publishedAt?: string

  /****  END_ALL_POST_COMMON_INFORMATIONS ****/

  /****  ALL_POST_SERVICES_INFORMATIONS ****/

  postserviceId?: number;
  postServiceTitle?: string;
  postServiceCategoryName?: string;
  postServiceDescription?: string;
  postServiceAllowEndPayement?: boolean;
  postServiceHomeService?: boolean;
  postServicePrice?: DoubleRange;
  postServicePhoto?: string;
  postServiceCode?: string;
  postServiceAvailableStatus?: boolean;
  postServiceAddress?: string;
  postServiceCityName?: string;
  postServiceCountryName?: string;
  postServiceCreatedAt?: Date;
  postServicePhoneFix?: string;
  postServicePhone?: string;

  /**** END_ALL_POST_SERVICES_INFORMATIONS ****/

  /****  ALL_POST_SERVICES_SHOP_INFORMATIONS ****/

  postServiceShopId?: number;
  postServiceShopName?: string;
  postServiceShopDescription?: string;
  postServiceShopCategoryName?: string;
  postServiceShopCityName?: string;
  postServiceShopCountryName?: string;
  postServiceShopZoneName?: string;
  postServiceShopCreateAt?: Date;
  postServiceShopDateStartAuthorisation?: Date;
  postServiceShopDateEndAuthorisation?: Date;
  postServiceShopMobilePhone?: string;
  postServiceShopFixPhone?: string;
  postServiceShopPhoto?: string;

  /****  END_ALL_POST_SERVICES_SHOP_INFORMATIONS ****/

  /****  ALL_POST_SERVICES_SHOP_SELLER_INFORMATIONS ****/

  postServiceShopSellerFirstName?: string;
  postServiceShopSellerLasttName?: string;
  postServiceShopSellerDomain?: string;
  postServiceShopSellerAddress?: string;
  postServiceShopSellerEmail?: string;
  postServiceShopSellerPhoneNumber?: string;

  /****  END_ALL_POST_SERVICES_SHOP_INFORMATIONS ****/

  /****  ALL_POST_PRODUCTS_INFORMATIONS ****/

  postProductId?: number;
  postProductID?: string;
  postProductName?: string;
  postProductPhoto?: string;
  postProductAllowDelivery?: boolean;
  postProductAllowPayementShipping?: boolean;
  postProductPrice?: DoubleRange;
  postProductCategoryId?: number;
  postProductCategoryName?: string;
  postProductCategoryDescription?: string;
  postProductAvailableStatus?: boolean;

  /****  ALL_POST_PRODUCTS_INFORMATIONS ****/

  /****  ALL_POST_PRODUCTS_SHOP_INFORMATIONS ****/

  postProductShopId?: number;
  postProductShopAddress?: string;
  postProductShopCategoryName?: string;
  postServiceShopCategoryDescription?: string;
  postProductShopCategoryDescription?: string;
  postProductShopChannelName?: string;
  postProductShopChannelNumber?: string;
  postProductShopCityName?: string;
  postProductShopCountryName?: string;
  postProductShopDescription?: string;
  postProductShopName?: string;
  postProductShopMobile?: string;
  postProductShopPhoto?: string;
  postProductShopZoneName?: string;

  /****  END_ALL_POST_PRODUCTS_SHOP_INFORMATIONS ****/

  /****  ALL_POST_PRODUCTS_SHOP_SELLER_INFORMATIONS ****/

  postProductShopSellerAdress?: string;
  postProductShopSellerDomainName?: string;
  postProductShopSellerEmail?: string;
  postProductShopSellerFirstName?: string;
  postProductShopSellerLastName?: string;
  postProductShopSellerPhone?: string;
  postProductShopSellerPhoneNumber?: string;
  postProductShopSellerResidenceCity?: string;
  postProductShopSellerResidenceCountry?: string;
  postProductShopSellerStreetName?: string;
  postProductShopSellerStreetDescription?: string;

  /****  END_ALL_POST_PRODUCTS_SHOP_SELLER_INFORMATIONS ****/

  /****  ALL_POST_GIFT_CARD_INFORMATIONS ****/

  postGiftCardId?: number;
  postGiftCardPrice?: DoubleRange;
  postGiftCardPhoto?: string;
  postGiftCardDescription?: string;
  boughtAt?: Date;
  expireAt?: Date;
  code?: string;
  giftCard?: GiftCard;
  unitPrice?: DoubleRange;
  user?: User;
  payementMethode?: string;
  userwalletID?: string;

  /****  END_ALL_POST_GIFT_CARD_INFORMATIONS ****/

  idCategoryPost?: number;
  quantity?: any;
  receiverId?: string;
  totalPriceGiftCard?: any;
  forWhat?: string;
  receiverID?: string;
  typeOfItem?: string;

}


export class PostProductServiceGiftInfos implements IPostProductServiceGiftInfos {
  constructor(
    /****  ALL_POST_COMMON_INFORMATIONS ****/

    public postId?: number, // ID de l'annonce
    public postTitle?: string, // Titre de l'annonce
    public postVipStatus?: boolean, // Annonce VIP ?
    public postDescription?: string, // Description de l'annonce
    public postPublishedDate?: Date, // Date de publication de l'annonce
    public postStatusName?: string, // Statut de l'annonce
    public postCategoryName?: string, // Category de l'annonce
    public publishedAt?: string,
    /****  END_ALL_POST_COMMON_INFORMATIONS ****/

    /****  ALL_POST_SERVICES_INFORMATIONS ****/

    public postServiceId?: number, // ID du service passé en annonce
    public postServiceTitle?: string, // Titre du service passé en annonce
    public postServiceCategoryName?: string, // Catégory du service passé en annonce
    public postServiceDescription?: string, // Description du service passé en annonce
    public postServiceAllowEndPayement?: boolean, // Si le payement après le service est accepté
    public postServiceHomeService?: boolean, // Si le service à domicile est accepté
    public postServicePrice?: DoubleRange, // Prix du service
    public postServicePhoto?: string, // Photo du service
    public postServiceCode?: string, // Code du service
    public postServiceAvailableStatus?: boolean, // Si le servic est accessible ou non
    public postServiceAddress?: string, // Addresse du  service
    public postServiceCityName?: string, // Ville associé au service
    public postServiceCountryName?: string, // Pays associé au service
    public postServiceCreatedAt?: Date, // Date de création du service
    public postServicePhoneFix?: string, // Numéro de téléphone fixe du service
    public postServicePhone?: string, // Numéro de téléphone mobile du service

    /**** END_ALL_POST_SERVICES_INFORMATIONS ****/

    /****  ALL_POST_SERVICES_SHOP_INFORMATIONS ****/

    public postServiceShopId?: number, // Identifiant de la boutique associée au service
    public postServiceShopName?: string, // Nom de la boutique associée au service
    public postServiceShopDescription?: string, // Description de la boutique associée au service
    public postServiceShopCategoryName?: string, // Category de la boutique associée au service
    public postServiceShopCategoryDescription?: string, // Description de la boutique associée au service
    public postServiceShopCityName?: string, // Ville de la boutique associée au service
    public postServiceShopCountryName?: string, // Pays de la boutique associée au service
    public postServiceShopZoneName?: string, // Zone de la boutique associée au service
    public postServiceShopCreateAt?: Date, // Date de création de la boutique associée au service
    public postServiceShopDateStartAuthorisation?: Date, // Date de délibération de l'autorisation spéciale d'exercer
    public postServiceShopDateEndAuthorisation?: Date, // Fin date d'autorisation spéciale d'exercer
    public postServiceShopMobilePhone?: string, // Téléphone mobile de la boutique associée au service
    public postServiceShopFixPhone?: string, // Téléphone fixe de la boutique associée au service
    public postServiceShopPhoto?: string, // Photo de la boutique associée au service

    /****  END_ALL_POST_SERVICES_SHOP_INFORMATIONS ****/

    /****  ALL_POST_SERVICES_SHOP_SELLER_INFORMATIONS ****/

    public postServiceShopSellerFirstName?: string, // Prénom du propriétaire de la boutique associée au service
    public postServiceShopSellerLasttName?: string, // Nom du propriétaire de la boutique associée au service
    public postServiceShopSellerDomain?: string, // Domaine d'exercie
    public postServiceShopSellerAddress?: string, // Adresse du propriétaire de la boutique
    public postServiceShopSellerEmail?: string, // Email du propriétaire de la boutique
    public postServiceShopSellerPhoneNumber?: string, // Numéro de téléphone du propriétaire de la boutique

    /****  END_ALL_POST_SERVICES_SHOP_INFORMATIONS ****/

    /****  ALL_POST_PRODUCTS_INFORMATIONS ****/

    public postProductId?: number, // Id du produit passé en annonce
    public postProductID?: string, // ID du produit passé en annonce de type chaine
    public postProductName?: string, // Nom du produit passé en annonce
    public postProductPhoto?: string, // Photo du produit passé en annonce
    public postProductAllowDelivery?: boolean, // Si la livraison accepté ?
    public postProductAllowPayementShipping?: boolean, // Si le payement après la livraison est accepté
    public postProductPrice?: DoubleRange, // Prix du produit passé en annonce
    public postProductCategoryId?: number,
    public postProductCategoryName?: string, // Nom de la catégorie du produit passé en annonce
    public postProductCategoryDescription?: string, // Description de la catégorie du produit passé en annonce
    public postProductAvailableStatus?: boolean, // Statut du produit passé en annonce

    /****  ALL_POST_PRODUCTS_INFORMATIONS ****/

    /****  ALL_POST_PRODUCTS_SHOP_INFORMATIONS ****/

    public postProductShopId?: number, // Identifiant de la boutique du produit passé en annonce
    public postProductShopAddress?: string, // Adresse de la boutique du produit passé en annonce
    public postProductShopCategoryName?: string, // Category de la boutique du produit passé en annonce
    public postProductShopCategoryDescription?: string, // Description de la catégory de la boutique du produit
    public postProductShopChannelName?: string, // Nom de la canal de la boutique
    public postProductShopChannelNumber?: string, // Numéro du canal de la boutique
    public postProductShopCityName?: string, // Ville de la boutique
    public postProductShopCountryName?: string, // Pays de la boutique
    public postProductShopDescription?: string, // Description de la boutique
    public postProductShopName?: string, // Nom de la boutique
    public postProductShopMobile?: string, // Numéro de téléphone mobile de la boutique
    public postProductShopPhoto?: string, // Photo de la boutique
    public postProductShopZoneName?: string, // Zone de la boutique

    /****  END_ALL_POST_PRODUCTS_SHOP_INFORMATIONS ****/

    /****  ALL_POST_PRODUCTS_SHOP_SELLER_INFORMATIONS ****/

    public postProductShopSellerAdress?: string, // Adresse du proprétaire de la boutique associé au produit
    public postProductShopSellerDomainName?: string, // Domaine du propriétaire de la boutique
    public postProductShopSellerEmail?: string, // Adresse email du propriétaire de la boutique
    public postProductShopSellerFirstName?: string, // Prénom du propriétaire de la boutique
    public postProductShopSellerLastName?: string, // Nom du proprétaire de la boutique
    public postProductShopSellerPhone?: string, // Numéro de téléphone mobile du vendeur
    public postProductShopSellerPhoneNumber?: string, // Numéro de téléphone fixe du vendeur
    public postProductShopSellerResidenceCity?: string, // Ville de résidence du vendeur
    public postProductShopSellerResidenceCountry?: string, // Pays de résidence du vendeur
    public postProductShopSellerStreetName?: string, // Rue ...
    public postProductShopSellerStreetDescription?: string, // Description ...

    /****  END_ALL_POST_PRODUCTS_SHOP_SELLER_INFORMATIONS ****/

    /****  ALL_POST_GIFT_CARD_INFORMATIONS ****/

    public postGiftCardId?: number, // Identifiant de la carte cadeau
    public postGiftCardPrice?: DoubleRange, // Prix de la carte cadeau
    public postGiftCardPhoto?: string, // Photo de la carte cadeau
    public postGiftCardDescription?: string, // Description de la carte cadeau
    public boughtAt?: Date,
    public expireAt?: Date,
    public code?: string,
    public giftCard?: GiftCard,
    public unitPrice?: DoubleRange,
    public user?: User,
    public payementMethode?: string,
    public userwalletID?: string,

    /****  END_ALL_POST_GIFT_CARD_INFORMATIONS ****/


    public idCategoryPost?: number,
    public quantity?: any,
    public receiverId?: string,
    public totalPriceGiftCard?: any,
    public forWhat?: string,
    public typeOfItem?: string,

  ) {
    this.postId = postId;
    this.postTitle = postTitle;
    this.postVipStatus = postVipStatus;
    this.postDescription = postDescription;
    this.postPublishedDate = postPublishedDate;
    this.postStatusName = postStatusName;
    this.postCategoryName = postCategoryName;
    this.publishedAt = publishedAt
    this.postServiceId = postServiceId;
    this.postServiceTitle = postServiceTitle;
    this.postServiceCategoryName = postServiceCategoryName;
    this.postServiceDescription = postServiceDescription;
    this.postServiceAllowEndPayement = postServiceAllowEndPayement;
    this.postServiceHomeService = postServiceHomeService;
    this.postServicePrice = postServicePrice;
    this.postServicePhoto = postServicePhoto;
    this.postServiceCode = postServiceCode;
    this.postServiceAvailableStatus = postServiceAvailableStatus;
    this.postServiceAddress = postServiceAddress;
    this.postServiceCityName = postServiceCityName;
    this.postServiceCountryName = postServiceCountryName;
    this.postServiceCreatedAt = postServiceCreatedAt;
    this.postServicePhoneFix = postServicePhoneFix;
    this.postServicePhone = postServicePhone;


    this.postServiceShopId = postServiceShopId;
    this.postServiceShopName = postServiceShopName;
    this.postServiceShopDescription = postServiceShopDescription;
    this.postServiceShopCategoryName = postServiceShopCategoryName;
    this.postServiceShopCategoryDescription = postServiceShopCategoryDescription;
    this.postServiceShopCityName = postServiceShopCityName;
    this.postServiceShopCountryName = postServiceShopCountryName;
    this.postServiceShopZoneName = postServiceShopZoneName;
    this.postServiceShopCreateAt = postServiceShopCreateAt;
    this.postServiceShopDateStartAuthorisation = postServiceShopDateStartAuthorisation;
    this.postServiceShopDateEndAuthorisation = postServiceShopDateEndAuthorisation;
    this.postServiceShopMobilePhone = postServiceShopMobilePhone;
    this.postServiceShopFixPhone = postServiceShopFixPhone;
    this.postServiceShopPhoto = postServiceShopPhoto;
    this.postServiceShopSellerFirstName = postServiceShopSellerFirstName;
    this.postServiceShopSellerLasttName = postServiceShopSellerLasttName;
    this.postServiceShopSellerDomain = postServiceShopSellerDomain;
    this.postServiceShopSellerAddress = postServiceShopSellerAddress;
    this.postServiceShopSellerEmail = postServiceShopSellerEmail;
    this.postServiceShopSellerPhoneNumber = postServiceShopSellerPhoneNumber;


    this.postProductId = postProductId;
    this.postProductID = postProductID;
    this.postProductName = postProductName;
    this.postProductPhoto = postProductPhoto;
    this.postProductAllowDelivery = postProductAllowDelivery;
    this.postProductAllowPayementShipping = postProductAllowPayementShipping;
    this.postProductPrice = postProductPrice;
    this.postProductCategoryId = postProductCategoryId;
    this.postProductCategoryName = postProductCategoryName;
    this.postProductCategoryDescription = postProductCategoryDescription;
    this.postProductAvailableStatus = postProductAvailableStatus;


    this.postProductShopId = postProductShopId;
    this.postProductShopAddress = postProductShopAddress;
    this.postProductShopCategoryName = postProductShopCategoryName;
    this.postProductShopCategoryDescription = postProductShopCategoryDescription;
    this.postProductShopChannelName = postProductShopChannelName;
    this.postProductShopChannelNumber = postProductShopChannelNumber;
    this.postProductShopCityName = postProductShopCityName;
    this.postProductShopCountryName = postProductShopCountryName;
    this.postProductShopDescription = postProductShopDescription;
    this.postProductShopName = postProductShopName;
    this.postProductShopMobile = postProductShopMobile;
    this.postProductShopPhoto = postProductShopPhoto;
    this.postProductShopZoneName = postProductShopZoneName;


    this.postProductShopSellerAdress = postProductShopSellerAdress;
    this.postProductShopSellerDomainName = postProductShopSellerDomainName;
    this.postProductShopSellerEmail = postProductShopSellerEmail;
    this.postProductShopSellerFirstName = postProductShopSellerFirstName;
    this.postProductShopSellerLastName = postProductShopSellerLastName;
    this.postProductShopSellerPhone = postProductShopSellerPhone;
    this.postProductShopSellerPhoneNumber = postProductShopSellerPhoneNumber;
    this.postProductShopSellerResidenceCity = postProductShopSellerResidenceCity;
    this.postProductShopSellerResidenceCountry = postProductShopSellerResidenceCountry;
    this.postProductShopSellerStreetName = postProductShopSellerStreetName;
    this.postProductShopSellerStreetDescription = postProductShopSellerStreetDescription;

    this.postGiftCardId = postGiftCardId;
    this.postGiftCardPrice = postGiftCardPrice;
    this.postGiftCardPhoto = postGiftCardPhoto;
    this.postGiftCardDescription = postGiftCardDescription;
    this.boughtAt = boughtAt;
    this.expireAt = expireAt;
    this.code = code;
    this.giftCard = giftCard;
    this.user = user;
    this.payementMethode = payementMethode;
    this.userwalletID = userwalletID;

    this.idCategoryPost = idCategoryPost;
    this.quantity = 1,
      this.receiverId = receiverId;
    this.totalPriceGiftCard = 0;
    this.forWhat = forWhat;
    this.typeOfItem = typeOfItem;
  }
}
